import { render, staticRenderFns } from "./coop_inst.vue?vue&type=template&id=4d45523e&scoped=true"
import script from "./coop_inst.vue?vue&type=script&lang=js"
export * from "./coop_inst.vue?vue&type=script&lang=js"
import style0 from "./coop_inst.vue?vue&type=style&index=0&id=4d45523e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@4.1.0_webpack@4.47.0__css-load_e869bb83501a535456d8ad6b2e6cd142/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45523e",
  null
  
)

export default component.exports